import React, { useEffect } from "react"
import { Button, Typography, Stack } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import ReplayIcon from "@mui/icons-material/Replay"
import { COLORS } from "../../../utils"
import { getReproductionNeedsSelector, getReproductionNeedsReloadedSelector, getReproductionNeedsLoadingSelector } from "../../../reducers/Alerts/alerts"
import ReproductionNeedsCard from "./ReproductionNeedsCard"

const sx = {
    reloadIcon: {
        transform: "scaleX(-1) rotate(-40deg)",
    },
    reloadButton: {
        fontSize: 16,
        textTransform: "none",
        color: COLORS.LABEL_GREY,
        fontWeight: 400
    },
    emptyData: {
        fontSize: "20px",
        color: COLORS.BLACK800,
        textAlign: "center",
        lineHeight: 1.4,
        fontWeight: 500
    },
}

const ReproductionNeeds = () => {
    const dispatch = useDispatch()
    const loading = useSelector(getReproductionNeedsLoadingSelector)

    const reproductionNeeds = useSelector(getReproductionNeedsSelector)
    const reloadedReproductionNeeds = useSelector(getReproductionNeedsReloadedSelector)

    /**
     * Pool function to reload the data every 5 minutes
     * @NOTE: The data is stored in the Redux store, so we can access it from any component
     */
    useEffect(() => {
        const interval = setInterval(() => {
            // This will fetch the data from the server and update the state
            // dispatch(getReproductionNeedsAlertsToReload())
        }, 5 * 60 * 1000) // 5 minutes
        return () => clearInterval(interval) // Cleanup the interval on component unmount
    }, [dispatch, reloadedReproductionNeeds.length])

    /**
     * Update the data table when the user clicks on the reload button
     * @NOTE: It's already in the Redux store (in the pool useEffect), so we just need to update the state
     * @returns 
     */
    const handleReload = () => console.log("Reload")

    return (
        <>
            {/* -------- header -------- */}
            <Stack direction="row" spacing={2} sx={{ px: 4, py: 2 }} justifyContent="space-between" alignItems="center">
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Reprods
                </Typography>
                <Button
                    variant="text"
                    onClick={handleReload}
                    startIcon={<ReplayIcon sx={sx.reloadIcon} color="primary" />}
                    sx={sx.reloadButton}
                >
                    {reloadedReproductionNeeds.length} changement{reloadedReproductionNeeds.length > 1 ? "s" : ""}
                </Button>
            </Stack>
            {!loading && reproductionNeeds.length === 0
            ? (
                <Stack sx={{ alignItems: "center", justifyContent: "center", mt: 10, pt: "0px", width: "100%" }}>
                    <Typography sx={sx.emptyData}>
                        Aucun besoin de reproduction identifié à ce jour
                    </Typography>
                </Stack>
            ) : (
                <Stack spacing={4} sx={{ px: 4, pb: "24px", pt: "0px", width: "100%" }}>
                    {reproductionNeeds.map((reprodNeed, index) => (
                        <ReproductionNeedsCard key={reprodNeed.key + index} reproductionNeed={reprodNeed} />
                    ))}
                </Stack>
            )}
 
        </>
    )
}

export default ReproductionNeeds